import { DisplaySettings } from "../reducers/displaySettingsReducer";
import { Filter, FilterState } from "../reducers/filtersReducer";

export const getFilterQueryString = (filters: FilterState):string =>{
  let filterQueryString = "";
  Object.entries(filters).forEach((entry: [string, Filter])=>{
    const [key, filter] = entry;
    if (filter.show && filter.value !== "") {
      filterQueryString += `${key}|${encodeURIComponent(filter.value)},`
    }
  });
  return filterQueryString;
};

export const getQueryString = (filterQueryString: string, {pagination, pageName, sort}: DisplaySettings):string =>{
  const queryStringArray: string[] = [
    `pageName=${pageName}`,
    `pageindex=${pagination.pageIndex}`,
    `pagesize=${pagination.pageSize}`,
  ];
  if (filterQueryString  !== "") {
    queryStringArray.push(`filterBy=${filterQueryString}`);
  }
  if (sort) {
    queryStringArray.push(`orderBy=${sort.headerToSort}|${sort.direction}`);
  }
  return queryStringArray.join("&");
};